module.exports = __webpack_public_path__ + "img/08-MobileGames-03.efc9ff89.png";